<template>
    <div class="product-details">
        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
                <a :href="tab1href" role="tab" data-toggle="tab">
                    {{ t('Price comparison') }}
                </a>
            </li>
            <li role="presentation" v-bind:class="{'disabled': !count_allegro}" >
                <a :href="tab5href" role="tab" data-toggle="tab">
                    {{ t('Allegro') }}
                </a>
            </li>
            <!--<li role="presentation">
                <a :href="tab8href" role="tab" data-toggle="tab">
                    {{ t('Products connected with allegro') }}
                </a>
            </li>-->
            <li role="presentation" v-bind:class="{'disabled': !count_ceneo}">
                <a :href="tab9href" role="tab" data-toggle="tab">
                    {{ t('Ceneo') }}
                </a>
            </li>
            <li role="presentation" v-bind:class="{'disabled': !count_amazon}">
                <a :href="tab19href" role="tab" data-toggle="tab">
                    {{ t('Amazon') }}
                </a>
            </li>
            <!--<li role="presentation">
                <a :href="tab2href" role="tab" data-toggle="tab">
                    {{ t('Price management') }}
                </a>
            </li>-->
            <!--<li role="presentation">
                <a :href="tab3href" role="tab" data-toggle="tab" @click="loadPriceExperiment()">
                    {{ t('Price tests') }}
                </a>
            </li>-->
            <li role="presentation">
                <a :href="tab4href" role="tab" data-toggle="tab" @click="loadPriceHistory()">
                    {{ t('History of prices') }}
                </a>
            </li>
            <li role="presentation" v-bind:class="{'disabled': !count_ceneo}">
                <a :href="tab10href" role="tab" data-toggle="tab" @click="loadPriceHistoryCeneo()">
                    {{ t('History of prices') }} - Ceneo
                </a>
            </li>
            <li role="presentation">
                <a :href="tab7href" role="tab" data-toggle="tab" @click="loadPriceHistoryHour()">
                    {{ t('Hourly price history') }}
                </a>
            </li>
            <!--<li role="presentation" v-bind:class="{'disabled': !count_ceneo}">-->
                <!--<a :href="tab21href" role="tab" data-toggle="tab" @click.prevent="loadPriceHistoryWithCeneo">-->
                    <!--{{ t('History of prices with ceneo') }}-->
                <!--</a>-->
            <!--</li>-->
            <li role="presentation" v-if="$data.showSimilar">
                <a :href="tab6href" role="tab" data-toggle="tab" @click="loadSimilar()">
                    {{ t('Similar') }}
                </a>
            </li>
            <li role="presentation">
                <a :href="tab20href" role="tab" data-toggle="tab" @click="loadWhoFirstDropPrice()">
                    {{ t('Who drop the price first') }}
                </a>
            </li>
            <!--<li role="presentation">-->
                <!--<a :href="tab22href" role="tab" data-toggle="tab" @click="loadMergeHistory()">-->
                    <!--{{ t('History of Merge') }}-->
                <!--</a>-->
            <!--</li>-->
            <li role="presentation">
                <a :href="tab23href" role="tab" data-toggle="tab" @click="loadSimilar()">
                    {{ t('Similar products') }}
                </a>
            </li>
            <li role="presentation">
                <a :href="'product-history/'+$data.id" target="_blank">
                    <span class="glyphicon glyphicon-stats"></span>
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" :id="tab1ID">

                <table class="table table-condensed">
                    <tr>
                        <th style="width:60px;">{{ t('Active') }}</th>
                        <th>{{ t('Shop') }}</th>
                        <th>{{ t('Product') }}</th>
                        <th>{{ t('Producer code') }}</th>
                        <th>{{ t('Price') }}</th>
                    </tr>
                    <tr v-for="offer in offers" class="offers">
                        <td v-bind:class="{'active': offer.active, 'inactive': !offer.active}">
                            <span v-if="offer.active">+</span><span v-else>-</span>
                        </td>
                        <td>{{offer.shop_name}}</td>
                        <td>
                            <a :href="offer.link" target="_blank">{{offer.name}}</a>
                        </td>
                        <td>{{offer.codes}}</td>
                        <td>{{offer.current_price}}</td>
                    </tr>
                </table>
            </div>
            <div role="tabpanel" class="tab-pane" :id="tab5ID">

                <div v-if="count_allegro">

                    <table class="table table-condensed">
                        <tr>
                            <th>{{ t('Product') }}</th>
                            <th>{{ t('Seller') }}</th>
                            <th>{{ t('Price') }}</th>
                            <th>{{ t('Views') }}</th>
                            <th>{{ t('Sale') }}</th>
                            <th>{{ t('Featured') }}</th>
                            <th>{{ t('Highlighted') }}</th>
                            <th>{{ t('Bold') }}</th>
                            <th>+ {{ t('Categories') }}</th>
                            <th>+ {{ t('Homepage') }}</th>
                        </tr>
                        <tr v-for="all in allegro">
                            <td>
                                <a :href="all.link" target="_blank">{{all.name}}</a>
                            </td>
                            <td>{{all.seller}}</td>
                            <td>{{all.current_price}}</td>
                            <td>{{all.views}}</td>
                            <td>{{all.quantity_sold}}</td>
                            <td class="text-center"><span v-if="all.promoted_by_featured" class="glyphicon glyphicon-ok text-success"></span></td>
                            <td class="text-center"><span v-if="all.promoted_by_highlight" class="glyphicon glyphicon-ok text-success"></span></td>
                            <td class="text-center"><span v-if="all.promoted_by_bold" class="glyphicon glyphicon-ok text-success"></span></td>
                            <td class="text-center"><span v-if="all.promoted_in_categories" class="glyphicon glyphicon-ok text-success"></span></td>
                            <td class="text-center"><span v-if="all.promoted_in_homepage" class="glyphicon glyphicon-ok text-success"></span></td>
                        </tr>
                    </table>

                </div>
                <div v-else>
                    {{ t('The tab is not available for this product') }}
                </div>
            </div>
            <div role="tabpanel" class="tab-pane" :id="tab9ID">
                <div v-if="count_ceneo">
                    <table class="table table-condensed">
                        <tr>
                            <th>{{ t('Product') }}</th>
                            <th>{{ t('Seller') }}</th>
                            <th>{{ t('Price') }}</th>
                        </tr>
                        <tr v-for="all in ceneo">
                            <td>
                                <a :href="all.link" target="_blank">{{all.name}}</a>
                            </td>
                            <td>{{all.seller}}</td>
                            <td>{{all.current_price}}</td>
                        </tr>
                    </table>
                </div>
                <div v-else>
                    {{ t('The tab is not available for this product') }}
                </div>
            </div>
            <div role="tabpanel" class="tab-pane" :id="tab19ID">
                <div v-if="count_amazon">
                    <div v-for="a in amazon">
                        <strong>{{ a.name }}</strong>
                        <table class="table table-condensed">
                            <tr>
                                <th>{{ t('Product') }}</th>
                                <th>{{ t('Price') }}</th>
                            </tr>
                            <tr v-for="all in a.list">
                                <td>
                                    <a :href="all.link" target="_blank">{{all.name}}</a>
                                </td>
                                <td>{{all.current_price}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div v-else>
                    {{ t('The tab is not available for this product') }}
                </div>
            </div>
            <div role="tabpanel" class="tab-pane" :id="tab8ID">
                <table class="table table-condensed">
                    <tr>
                        <th>{{ t('Product') }}</th>
                        <th>{{ t('Shop') }}</th>
                        <th>{{ t('Seller') }}</th>
                        <th>{{ t('Price') }}</th>
                        <th>{{ t('Views') }}</th>
                        <th>{{ t('Sale') }}</th>
                        <th>{{ t('Featured') }}</th>
                        <th>{{ t('Highlighted') }}</th>
                        <th>{{ t('Bold') }}</th>
                        <th>+ {{ t('Categories') }}</th>
                        <th>+ {{ t('Homepage') }}</th>
                    </tr>
                    <tr v-for="all in mapped_allegro">
                        <td>
                            <a :href="all.link" target="_blank">{{all.name}}</a>
                        </td>
                        <td>{{all.shop}}</td>
                        <td>{{all.seller}}</td>
                        <td>{{all.current_price}}</td>
                        <td>{{all.views}}</td>
                        <td>{{all.quantity_sold}}</td>
                        <td class="text-center"><span v-if="all.promoted_by_featured" class="glyphicon glyphicon-ok text-success"></span></td>
                        <td class="text-center"><span v-if="all.promoted_by_highlight" class="glyphicon glyphicon-ok text-success"></span></td>
                        <td class="text-center"><span v-if="all.promoted_by_bold" class="glyphicon glyphicon-ok text-success"></span></td>
                        <td class="text-center"><span v-if="all.promoted_in_categories" class="glyphicon glyphicon-ok text-success"></span></td>
                        <td class="text-center"><span v-if="all.promoted_in_homepage" class="glyphicon glyphicon-ok text-success"></span></td>
                    </tr>
                </table>
            </div>
            <div role="tabpanel" class="tab-pane" :id="tab2ID">
                {{ t('Price management') }}
            </div>
            <div role="tabpanel" class="tab-pane" :id="tab3ID">
                <div></div>
            </div>
            <div role="tabpanel" class="tab-pane price-history" :id="tab4ID">
                <div></div>
            </div>
            <div role="tabpanel" class="tab-pane price-history-ceneo" :id="tab10ID">

                <div v-if="count_ceneo">
                    <div v-show="priceHistoryCeneo.loading" class="loading-fragment"><div class="dataTables_processing panel panel-default">{{ t('Processing') }}...</div></div>
                    <div v-show="!priceHistoryCeneo.loading">

                        <button @click="priceHistoryCeneo.chartOpened = !priceHistoryCeneo.chartOpened" class="btn btn-default">{{ t('Fullscreen') }}</button>

                        <hr />

                        <default-chart :labels="priceHistoryCeneo.labels" :items="priceHistoryCeneo.items" :height="75" :options="{responsive: true, legend: {display: false}, scales: {yAxes: [{ticks: {beginAtZero: false}}]}}"></default-chart>

                        <div class="fullscreen-chart" v-bind:class="{'opened': priceHistoryCeneo.chartOpened}">

                            <br />

                            <div class="panel">
                                <div class="text-center" style="margin:auto;">
                                    <div v-show="priceHistoryCeneo.loading" class="loading-fragment"><div class="dataTables_processing panel panel-default">{{ t('Processing') }}...</div></div>
                                    <div v-show="!priceHistoryCeneo.loading">
                                        <datepicker name="from" ref="fromDate" style="margin:auto;text-align:center;"
                                                    :placeholder="datePicker.placeholder"
                                                    :language="datePicker.language"
                                                    :monday-first="true"
                                                    :format="datePicker.dateFormat"
                                                    :disabled="datePicker.disabled"
                                                    v-model="priceHistoryCeneo.date"
                                                    :disabled-picker="datePicker.disabledPicker"

                                                    :calendar-button="true"
                                                    clear-button-icon="glyphicon glyphicon-remove"
                                                    calendar-button-icon="glyphicon glyphicon-time"

                                                    @input="priceHistoryCeneoChange"
                                        ></datepicker>
                                    </div>
                                </div>

                                <br />

                                <div class="text-center">
                                    <button @click="priceHistoryCeneo.chartOpened = !priceHistoryCeneo.chartOpened" class="btn btn-default">{{ t('Hide') }}</button>
                                </div>

                                <default-chart :labels="priceHistoryCeneo.labels" :items="priceHistoryCeneo.items" :height="135" :options="{responsive: true, scales: {yAxes: [{ticks: {beginAtZero: false,}}]}}"></default-chart>

                            </div>

                        </div>

                    </div>
                </div>
                <div v-else>
                    {{ t('The tab is not available for this product') }}
                </div>

            </div>
            <div role="tabpanel" class="tab-pane price-history-hour" :id="tab7ID">

                <div v-show="priceHistoryHour.loading" class="loading-fragment"><div class="dataTables_processing panel panel-default">{{ t('Processing') }}...</div></div>
                <div v-show="!priceHistoryHour.loading">

                    <datepicker name="from" ref="fromDate"
                                :placeholder="datePicker.placeholder"
                                :language="datePicker.language"
                                :monday-first="true"
                                :format="datePicker.dateFormat"
                                :disabled="datePicker.disabled"
                                v-model="priceHistoryHour.date"
                                :disabled-picker="datePicker.disabledPicker"

                                :calendar-button="true"
                                clear-button-icon="glyphicon glyphicon-remove"
                                calendar-button-icon="glyphicon glyphicon-time"

                                @input="priceHistoryHourChange"
                    ></datepicker>

                    <br/>

                    <default-chart :labels="priceHistoryHour.labels" :items="priceHistoryHour.items" :height="75" />

                </div>
            </div>
            <div role="tabpanel" class="tab-pane price-history-with-ceneo" :id="tab21ID">
                <div></div>
            </div>
            <div role="tabpanel" class="tab-pane similar-products" :id="tab6ID">
                <div></div>
            </div>
            <div role="tabpanel" class="tab-pane" :id="tab20ID">
                <div v-show="this.whoFirstDropPrice.loading" class="loading-fragment"><div class="dataTables_processing panel panel-default">{{ t('Processing') }}...</div></div>
                <span v-show="!this.whoFirstDropPrice.loading">
                    <form v-on:submit.prevent="whoFirstDropPriceSearch">
                        <label for="srp">{{ t('SRP price') }}: </label>
                        <money id="srp" v-model="whoFirstDropPrice.price"></money>
                        <date-range-picker
                                v-model="whoFirstDropPrice.date"
                        ></date-range-picker>

                        <button class="btn btn-confirm">{{ t('Search') }}</button>
                    </form>
                    <table class="table table-condensed" v-if="whoFirstDropPrice.items.length>0">
                        <tr>
                            <th>{{ t('Shop') }}</th>
                            <th>{{ t('Name') }}</th>
                            <th>{{ t('Price') }}</th>
                            <th>{{ t('Date') }}</th>
                        </tr>
                        <tr v-for="item in whoFirstDropPrice.items">
                            <td>{{item.shop}}</td>
                            <td>{{item.name}}</td>
                            <td>{{item.price}}</td>
                            <td>{{item.date}}</td>
                        </tr>
                    </table>
                    <div v-else>{{ t('Not found') }}.</div>
                </span>
            </div>
            <div role="tabpanel" class="tab-pane merge-history" :id="tab22ID">
                <div>
                    <div v-show="loading" class="loading-fragment">
                        <div class="dataTables_processing panel panel-default">
                            {{ t('Processing') }}...
                        </div>
                    </div>
                    <div v-show="!loading">

                        <div v-if="!mergeHistory.length">
                            {{ t('No data') }}
                        </div>
                        <div v-else>
                            <table class="table table-condensed">
                                <thead>
                                    <tr>
                                        <th style="width:40px"></th>
                                        <th style="width:170px;">{{ t('Shop') }}</th>
                                        <th>{{ t('Product') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in mergeHistory">
                                        <td>
                                            <span v-if="item.added" class="text-success glyphicon glyphicon-plus"></span>
                                            <span v-else-if="item.removed" class="text-danger glyphicon glyphicon-minus"></span>
                                            <!--<span class="glyphicon" v-else></span>-->
                                        </td>
                                        <td>
                                            {{ item.shop_name }}
                                            <span v-if="item.seller_name"> - {{ item.seller_name }}</span>
                                        </td>
                                        <td><a :href="item.link" taget="_blank">{{ item.name }}</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
            <div role="tabpanel" class="tab-pane similar" :id="tab23ID">
                <div>
                    <div v-show="loading" class="loading-fragment">
                        <div class="dataTables_processing panel panel-default">
                            {{ t('Processing') }}...
                        </div>
                    </div>
                    <div v-show="!loading">

                        <label>
                            <input type="checkbox" v-model="similarOtherBrand" @change="loadSimilar()" /> {{ t('Other brand') }}
                        </label>

                        <table class="table table-condensed">
                            <thead>
                                <tr>
                                    <th>{{ t('Product') }}</th>
                                    <th>{{ t('Brand') }}</th>
                                    <th>{{ t('Shop') }}</th>
                                    <th>{{ t('Price') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in similar">
                                    <td><a :href="item.link" target="_blank">{{ item.name }}</a></td>
                                    <td>{{ item.brand_name }}</td>
                                    <td>{{ item.shop_name }}</td>
                                    <td>{{ item.price | currency }} <small>{{ item.diff }}%</small></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    require('bootstrap');

    import Vue from 'vue'
    import PriceHistoryChart from './productDetails/PriceHistoryChart'
    import PriceExperiment from './productDetails/PriceExperiment.vue'
    import SimilarProducts from './productDetails/SimilarProducts.vue'
    import Datepicker from 'vuejs-datepicker';
    import DateRangePicker from './DateRangePicker.vue'
    import DefaultChart from './DefaultChart';
    import lang from '../services/lang';
    import {Money} from 'v-money';
    import CustomDatepicker from './Datepicker.vue';

    import PriceHistory from './Product/PriceHistory.vue'
    import PriceHistoryWithCeneo from './Product/PriceHistoryWithCeneo.vue';

    let PriceExperimentLoader = Vue.extend(PriceExperiment);
    let SimilarProductsLoader = Vue.extend(SimilarProducts);

    let PriceHistoryLoader = Vue.extend(PriceHistory)
    let PriceHistoryWithCeneoLoader = Vue.extend(PriceHistoryWithCeneo);

    const moment = require('moment');

    export default {
        data() {
            let whoFirstDropPriceFrom=new Date();
            whoFirstDropPriceFrom.setMonth(whoFirstDropPriceFrom.getMonth()-1);
            return {
                similar: [],
                similarOtherBrand: false,
                mergeHistory: [],
                chartOpened: false,
                currentLanguage: lang.current(),
                showDuplicatesModal: false,
                currentDuplicates: [],
                priceHistory: {
                    labels: [],
                    items: [],
                    loaded: false,
                    loading: false,
                },
                priceHistoryCeneo: {
                    labels: [],
                    items: [],
                    loaded: false,
                    loading: false,
                    chartOpened: false,
                    date: null,
                },
                priceHistoryHour: {
                    date:null,
                    labels: [],
                    items: [],
                    loading: false,
                },
                whoFirstDropPrice: {
                    price: 0,
                    date: {
                        from: whoFirstDropPriceFrom,
                        to: new Date(),
                    },
                    items: [],
                    loading: false,
                },
                datePicker:{
                    "dateFormat": 'dd.MM.yyyy',
                    "placeholder": 'Dzień',
                    "language": lang.current(),
                    "dateStart": {},

                    "disabled": {
                        type: Object,
                        default() {
                            return null;
                        },
                    },
                    "hightlighted": {
                        type: Object,
                        default() {
                            return {
                                dates: []
                            }
                        }
                    },
                    "disabledPicker": false,
                },
                priceHistoryWithCeneo: {
                    labels: [],
                    items: [],
                    loaded: false,
                    loading: false,
                },
                chartOptions: {responsive: true, legend: {display: false}, scales: {yAxes: [{ticks: {beginAtZero: false}}]}},
                mydate: null,
                chartDateRangePicker: {
                    values: {
                        from: null,
                        to: null,
                    },
                    fromDisabled: {
                        from: null,
                        to: null
                    },
                    toDisabled: {
                        from: null,
                        to: null
                    }
                },
                chartDateRangePickerCeneo: {
                    values: {
                        from: null,
                        to: null,
                    },
                    fromDisabled: {
                        from: null,
                        to: null
                    },
                    toDisabled: {
                        from: null,
                        to: null
                    }
                },
                count_allegro: 0,
                count_ceneo: 0,
                count_amazon: 0,
                loading: false,
            }
        },
        components: {
            DefaultChart,
            PriceExperiment,
            Datepicker,
            Money,
            DateRangePicker,
            PriceHistoryWithCeneo,
            CustomDatepicker
        },
        computed: {
            tab1ID() {
                return 'tab1_' + this.$data.id
            },
            tab2ID() {
                return 'tab2_' + this.$data.id
            },
            tab3ID() {
                return 'tab3_' + this.$data.id
            },
            tab4ID() {
                return 'tab4_' + this.$data.id
            },
            tab5ID() {
                return 'tab5_' + this.$data.id
            },
            tab6ID() {
                return 'tab6_' + this.$data.id
            },
            tab7ID() {
                return 'tab7_' + this.$data.id
            },
            tab8ID() {
                return 'tab8_' + this.$data.id
            },
            tab9ID() {
                return 'tab9_' + this.$data.id
            },
            tab10ID() {
                return 'tab10_' + this.$data.id
            },
            tab19ID() {
                return 'tab19_' + this.$data.id
            },
            tab20ID() {
                return 'tab20_' + this.$data.id
            },
            tab21ID() {
                return 'tab21_' + this.$data.id
            },
            tab22ID() {
                return 'tab22_' + this.$data.id
            },
            tab23ID() {
                return 'tab23_' + this.$data.id
            },
            tab1href() {
                return '#tab1_' + this.$data.id
            },
            tab2href() {
                return '#tab2_' + this.$data.id
            },
            tab3href() {
                return '#tab3_' + this.$data.id
            },
            tab4href() {
                return '#tab4_' + this.$data.id
            },
            tab5href() {
                return '#tab5_' + this.$data.id
            },
            tab6href() {
                return '#tab6_' + this.$data.id
            },
            tab7href() {
                return '#tab7_' + this.$data.id
            },
            tab8href() {
                return '#tab8_' + this.$data.id
            },
            tab9href() {
                return '#tab9_' + this.$data.id
            },
            tab10href() {
                return '#tab10_' + this.$data.id
            },
            tab19href() {
                return '#tab19_' + this.$data.id
            },
            tab20href() {
                return '#tab20_' + this.$data.id
            },
            tab21href() {
                return '#tab21_' + this.$data.id;
            },
            tab22href() {
                return '#tab22_' + this.$data.id;
            },
            tab23href() {
                return '#tab23_' + this.$data.id;
            }
        },
        mounted() {
        },
        methods: {
            showDuplicates(items) {
                this.currentDuplicates = items;
                this.showDuplicatesModal = true;
            },
            loadPriceHistory() {
                new PriceHistoryLoader({data: {id: this.id, last_import_day: this.$data.last_import_day}}).$mount($(this.tab4href).find('div')[0])
            },
            loadPriceHistoryCeneo()
            {
                if (!this.priceHistoryCeneo.loaded) {
                    this.priceHistoryCeneo.date = new Date(this.$data.last_import_day)
                }

                this.priceHistoryCeneo.loading = true;

                this.$http.get('reports/price-history-ceneo/'+this.$data.id, {params: {day: this.priceHistoryCeneo.date ? this.customFormat(this.priceHistoryCeneo.date) : null }}).then(response =>
                {
                    this.priceHistoryCeneo.loading = false;
                    this.priceHistoryCeneo.loaded = true;

                    this.priceHistoryCeneo.items = response.body.items;
                    this.priceHistoryCeneo.labels = response.body.labels;
                }, response => {
                    this.priceHistoryCeneo.loading = false;
                });
            },
            customFormat: function(date) {
                return moment(date).format('DD.MM.YYYY');
            },
            onSelectedDateOfPriceHistory: function ()
            {
                if (this.chartDateRangePicker.values.to) {
                    this.updateHistory();
                }
            },
            updateHistory: function()
            {
                this.priceHistory.loading = true;

                this.$http.get('reports/pricehistory/' + this.$data.id, {params: {
                        'to': this.customFormat(this.chartDateRangePicker.values.to),
                    }}).then(response => {
                        console.log(response.body);
                    this.priceHistory = response.body;
                    this.priceHistory.loaded = true;
                    this.priceHistory.loading = false;
                });
            },
            loadPriceHistoryHour()
            {
                if (!this.priceHistoryHour.date) {
                    if (this.$data.last_import_day) {
                        this.priceHistoryHour.date = new Date(this.$data.last_import_day);
                    }
                }

                this.priceHistoryHour.loading = true;

                this.$http.post('reports/priceHistoryHour/' + this.$data.id, {date:this.priceHistoryHour.date}).then(response => {
                    this.priceHistoryHour.loading = false;
                    this.priceHistoryHour = response.body;
                }, () => {
                    this.priceHistoryHour.loading = false;
                });
            },
            loadPriceExperiment() {
                new PriceExperimentLoader({data: {id: this.id}}).$mount($(this.tab3href).find('div')[0])
            },
            loadSimilar() {
                new SimilarProductsLoader({data: {id: this.id}}).$mount($(this.tab6href).find('div')[0])
            },
            loadWhoFirstDropPrice() {
                this.whoFirstDropPrice.price = this.$data.price;
            },
            priceHistoryHourChange: function(value) {
                this.priceHistoryHour.date=value;
                this.loadPriceHistoryHour();
            },
            priceHistoryCeneoChange: function(value)
            {
                this.priceHistoryCeneo.date = value;
                this.loadPriceHistoryCeneo();
            },
            whoFirstDropPriceSearch() {
                this.whoFirstDropPrice.loading=true;
                this.$http.post('product-detail/whoFirstDropPrice', {
                    id: this.$data.id,
                    price: this.whoFirstDropPrice.price,
                    date:this.whoFirstDropPrice.date,
                }).then(response => {
                    this.whoFirstDropPrice = response.body;
                    this.whoFirstDropPrice.loading=false;
                });
            },
            priceHistoryWithCeneoChange: function(value) {

            },
            loadPriceHistoryWithCeneo: function() {
                new PriceHistoryWithCeneoLoader({data: {id: this.id, last_import_day: this.$data.last_import_day}}).$mount($(this.tab21href).find('div')[0])
            },
            loadMergeHistory()
            {
                this.loading = true;
                this.$http.get('reports/merge-history', {params: {id: this.id}}).then(response => {
                    this.loading = false;
                    this.mergeHistory = response.body;
                });
            },
            loadSimilar()
            {
                this.loading = true;
                this.$http.get('reports/similar', {params: {id: this.id, 'other_brand': this.similarOtherBrand ? 1 : 0}}).then(response => {
                    this.loading = false;
                    this.similar = response.body;
                })
            }
        }
    }
</script>

<style lang="sass">

    .offers
    {
        .active{color:green;}
        .inactive{color:red;}
    }

    .price-history-ceneo .vdp-datepicker{
        float:none;
    }
        .fullscreen-chart
    {
        width:0;
        height:0;
        overflow:hidden;

        .panel {
            display:none;
    }

        &.opened
    {
        display:block;
        position:fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background-color:white;
        overflow:visible;
        z-index:9999;

        .panel {
            display:block;
    } } }

        .highlighted {
            background-color:red;
    }
        .product-details {
            .tab-content {
                background: #fff;
                padding: 20px;
    }

        .price-history-content {
            width: 450px;
    }

        .modal-mask {
            position:fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display:table;
            transition:opacity .3 s ease;
    }

        .modal-wrapper {
            display:table-cell;
            vertical-align:middle;
    }

        .modal-container {
            width: 550px;
            margin: 0px auto;
            padding: 20px 30px;
            background-color: #fff;
            border-radius: 2px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
            transition:all .3 s ease;
    }

        .modal-body {
            margin: 10px 0;
    }

        .modal-enter .modal-container, .modal-leave-active .modal-container {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
    } }


        .v-money {
            vertical-align: middle;
            border: 1px solid #6d6e70;
            border-radius: 3px;
            padding: 7px 5px 5px 5px;
            font-size: 16px;
    }
        .daterange-picker{
            vertical-align: middle;
            display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// ProductDetails.vue?63b1d3fa